export const PATHS = {
  ROOT: '/',
  BOOKING: '/booking',
  LOGIN: '/login',
  VIEW_BOOKINGS: '/view-bookings',
  VIEW_BOOKING: '/view-booking',
  PASSWORD_RECOVERY: '/password-recovery',
  VERIFICATION_CODE: '/verification-code',
  CHANGE_PASSWORD: '/change-password',
};
